"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchTextBoxSubDocumentsStateHistoryItem = void 0;
var tslib_1 = require("tslib");
var history_item_1 = require("../base/history-item");
var SwitchTextBoxSubDocumentsStateHistoryItem = (function (_super) {
    tslib_1.__extends(SwitchTextBoxSubDocumentsStateHistoryItem, _super);
    function SwitchTextBoxSubDocumentsStateHistoryItem(modelManipulator, oldSubDocument, textBoxParentSubDocument, position) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.oldSubDocument = oldSubDocument;
        _this.textBoxParentSubDocument = textBoxParentSubDocument;
        _this.position = position;
        return _this;
    }
    SwitchTextBoxSubDocumentsStateHistoryItem.prototype.redo = function () {
        this.oldSubDocument = this.oldSubDocument.getActualSubDocument();
        var newRun = this.textBoxParentSubDocument.getRunAndIndexesByPosition(this.position).run;
        this.newSubDocument = this.modelManipulator.model.subDocuments[newRun.subDocId];
        this.modelManipulator.model.subDocumentsCollection.replace(this.oldSubDocument.id, this.newSubDocument.id);
        this.copyPropertiesToLastParagraph(this.oldSubDocument, this.newSubDocument);
    };
    SwitchTextBoxSubDocumentsStateHistoryItem.prototype.undo = function () {
        this.modelManipulator.model.subDocumentsCollection.replace(this.newSubDocument.id, this.oldSubDocument.id);
    };
    SwitchTextBoxSubDocumentsStateHistoryItem.prototype.copyPropertiesToLastParagraph = function (sourceSubDocument, targetSubDocument) {
        var newParagraph = targetSubDocument.paragraphs[targetSubDocument.paragraphs.length - 1];
        var oldParagraph = sourceSubDocument.paragraphs[targetSubDocument.paragraphs.length - 1];
        this.modelManipulator.paragraph.applyParagraphProperties(newParagraph, oldParagraph, false, oldParagraph.getParagraphBundleFull(sourceSubDocument.documentModel));
    };
    return SwitchTextBoxSubDocumentsStateHistoryItem;
}(history_item_1.HistoryItem));
exports.SwitchTextBoxSubDocumentsStateHistoryItem = SwitchTextBoxSubDocumentsStateHistoryItem;
